<div class="row mb-5">
  <div class="col-6 d-none d-md-block">
    <span class="text-montserrat text-500 text-18 text-2670E0 mb-0">
      {{ item?.title || '' }}
    </span>
  </div>
  <div class="col-12 col-md-6">
    <div class="d-flex align-items-center justify-content-end">
      @for (crumb of item.breadcrumbs; let i = $index; track i) {
        <ng-container>
          @if (crumb.link && i < item.breadcrumbs.length - 1) {
            <a [routerLink]="crumb.link"
               class="text-decoration-none text-montserrat text-500 text-12 text-1D2345 cursor-pointer">
              {{ crumb?.label }}
            </a>
          }
  
          @if (i === item.breadcrumbs.length - 1) {
            <span class="text-montserrat text-700 text-12 text-1D2345">
              {{ crumb?.label }}
            </span>
          }
  
          @if (i < item.breadcrumbs.length - 1) {
            <span class="text-montserrat text-500 text-12 text-1D2345 px-3">/</span>
          }
        </ng-container>
      }
    </div>
  </div>
  <div class="col-12 d-md-none mt-2">
    <span class="text-montserrat text-500 text-18 text-2670E0 mb-0">
      {{ item?.title || '' }}
    </span>
  </div>
</div>